const base = import.meta.env.BASE_URL.endsWith('/')
    ? import.meta.env.BASE_URL
    : `${import.meta.env.BASE_URL}/`;

export const maestroLogo = `${base}maestro-logo.svg`;
export const maestroIcon = `${base}maestro-icon.svg`;